export default {
    apiUrl: 'http://api.bukku.local',
};

const siteConfig = {
    siteName: 'BUKKU',
    siteIcon: 'bold',
    footerText: '© 2019 Bukku Technology Solutions',
    enableAnimatedRoute: false,
};
const themeConfig = {
    topbar: 'themedefault',
    sidebar: 'themedefault',
    layout: 'themedefault',
    theme: 'themedefault',
};
const language = 'english';
const AlgoliaSearchConfig = {
    appId: '',
    apiKey: '',
};
const Auth0Config = {
    domain: 'redq.auth0.com',
    clientID: '',
    allowedConnections: ['Username-Password-Authentication'],
    rememberLastLogin: true,
    language: 'en',
    closable: true,
    options: {
        auth: {
            autoParseHash: true,
            responseType: 'token id_token',
            redirect: true,
            redirectUrl: 'http://localhost:3000/auth0loginCallback',
        },
        languageDictionary: {
            title: 'Isomorphic',
            emailInputPlaceholder: 'demo@gmail.com',
            passwordInputPlaceholder: 'demodemo',
        },
        theme: {
            labeledSubmitButton: true,
            logo: 'https://s3.amazonaws.com/redqteam.com/logo/isomorphic.png',
            primaryColor: '#E14615',
            authButtons: {
                connectionName: {
                    displayName: 'Log In',
                    primaryColor: '#b7b7b7',
                    foregroundColor: '#000000',
                },
            },
        },
    },
};
const firebaseConfig = {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
};
const googleConfig = {
    apiKey: '',
};
const mapboxConfig = {
    tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    maxZoom: 18,
    defaultZoom: 11,
    center: [40.706877, -74.011265],
};

const youtubeSearchApi = '';

const accountKitConfig = {
    appId: '',
    state: 'csrf',
    version: 'v1.0',
    fbAppEventsEnabled: true,
    redirect: 'https://a1021477.ngrok.io/',
    debug: process.env.NODE_ENV !== 'production',
};

export {
    siteConfig,
    language,
    themeConfig,
    AlgoliaSearchConfig,
    Auth0Config,
    firebaseConfig,
    googleConfig,
    mapboxConfig,
    youtubeSearchApi,
    accountKitConfig,
};
